'use strict';

function vpswitchQuestions(currentQuestion, newQuestion) {
    $('.vital-perfect-form #question-' + currentQuestion).removeClass('active').hide();
    $('.vital-perfect-form #question-' + newQuestion).addClass('active').show();
    $('.vital-perfect-form .current-question').val(newQuestion);
}

function vphandlePrevNextLinks(newQuestion) {
    var prevLink = $('.vp-full-page-modal .js-quiz-back'),
        nextLink = $('.vp-full-page-modal .js-quiz-next'),
        firstQuestion = 0,		
        lastQuestion = $('.vp-full-page-modal .question.main').length - 1;	
	
    if(newQuestion === firstQuestion) {
        prevLink.addClass('disabled');		
    } else {
        prevLink.removeClass('disabled');
    }
}

function vpupdateSubmitButtonState() {
    var activeQuestion = $('.vital-perfect-form .question.active'),
        nextLink = $('.vital-perfect-form .js-quiz-next');

    if (activeQuestion.data('mandatory')) {
        var inputs = activeQuestion.find('.js-answer-option');		
        nextLink.attr('disabled', !inputs.is(':checked'));
    } else {
        nextLink.attr('disabled', false);
    }
}

function vpbindQuizEvents() {
	
    $('.vp-full-page-modal .js-quiz-next').on('click', function () {
        //go back to the question on click of next.
        $(this).closest('.modal-wrapper').scrollTop(0);
        var activeQuestion = $('.question.active');
        var currentQuestion = parseInt($('.current-question').val(), 10);
        var nextQuestion = currentQuestion + 1;		
		
        //check current active page = last page
        var activeCurrQuestion =  $('.vital-perfect-form .question.main.active').data('question-number') ? $('.vital-perfect-form .question.main.active').data('question-number') : 0;
        var mainQuesCount = parseInt($('#main-ques-count').val(), 10) - 1;
		
        if(activeCurrQuestion == mainQuesCount){
            getMAinQuesRedirect();
        }
		
        //additional queries
        var activeAddCurrQuestion =  $('.vital-perfect-form .question.additional.active').data('question-number') ? $('.vital-perfect-form .question.additional.active').data('question-number') : 0;
        var addQuesCount = parseInt($('#add-ques-count').val(), 10) + mainQuesCount;
		
        if(activeAddCurrQuestion == addQuesCount){
            getAddQuesRedirect();
        }	
		
		
        vpswitchQuestions(currentQuestion, nextQuestion);
        vpupdateSubmitButtonState();
        vphandlePrevNextLinks(nextQuestion);	
			
        //loader
        var curQuest = parseInt($('.vital-perfect-form .question.active').data('question-number')) + 1;
        var total = $('.vital-perfect-form .question.main.active').data('question-number') ? mainQuesCount + 1 : addQuesCount + 1;
        loaderFormation(curQuest,total);

    });

    $('.vp-full-page-modal .js-quiz-back').on('click', function () {
        var currentQuestion = parseInt($('.current-question').val(), 10);
        var prevQuestion = currentQuestion - 1;			
		
	
        vpswitchQuestions(currentQuestion, prevQuestion);
        vpupdateSubmitButtonState();
        vphandlePrevNextLinks(prevQuestion);
		
        //loader
        var curQuest = parseInt($('.vital-perfect-form .question.active').data('question-number')) + 1;
        var mainQuesCount = parseInt($('#main-ques-count').val(), 10) - 1;
        var addQuesCount = parseInt($('#add-ques-count').val(), 10) + mainQuesCount;
        var total = $('.vital-perfect-form .question.main.active').data('question-number') ? mainQuesCount + 1 : addQuesCount + 1;
        loaderFormation(curQuest,total);
    });


    $('.vp-full-page-modal .js-answer-option').on('click', function () {		
        vpupdateSubmitButtonState();
    });
}

/**
 * Loader
 */
function loaderFormation(curQuest,total){
    var perc = Math.round(((curQuest/total) * 100).toFixed(3));
    $('.progress-circle').attr('data-percentage', perc);
	
    $('span.progres-span').text(curQuest+'/'+total);
}
/**
 * redirect depending upon - weigtage and campaign
 */
function defineRedirects(camp_enb,mainWeighted){
	
    if(camp_enb == 'true' && mainWeighted == true){
        displayProgressWait();		
        window.location.href = decodeURI($('#weighted_active').val());
		 return;
    }
	
    if((camp_enb == 'false' && mainWeighted == false) || (camp_enb == 'true' && mainWeighted == false)){
        displayProgressWait();		
        window.location.href = decodeURI($('#non_weighted').val());
		 return;
    }	
}

/**
 * Show loader
 */
function displayProgressWait(){
    var vpquizModal = $('#vp-quiz-form'),
        vpquizLoader = vpquizModal.find('.vp-ajax-loader');

    vpquizLoader.show();
}

/**
 * main questions redirects
 */
function getMAinQuesRedirect(){
    var check_value = $('input:radio.js-answer-option.main:checked');
    var countWeigt = 0;
    var mainWeighted=false;
	
    $(check_value).each(function(i){		
        if($('#main-ques-weigt_opt').val() == $(this).val()){
            countWeigt++;
        }
    });	
	
    if(countWeigt >= $('#main-ques-weigt_count').val()){
        mainWeighted = true;
    }	
	
    defineRedirects($('#camp_enabled').val(),mainWeighted);
}

/**
 * additional questions redirects
 */
function getAddQuesRedirect(){
    var check_value = $('input:radio.js-answer-option.additional:checked');
    var checkStr = '';
    var jsonData =  $('#weighted_inactive').val();
    jsonData = JSON.parse(jsonData);	
	
    $(check_value).each(function(i){
        checkStr += $(this).val();
		
    });	
	
    for (var key in jsonData) {
        if (jsonData.hasOwnProperty(key)) {		  
		  if(checkStr == key){
			  displayProgressWait();			  
			  window.location.href = decodeURI(jsonData[key]);
			  return;
		  }
        }
    }
	
    displayProgressWait();	
	 window.location.href = decodeURI($('#non_weighted').val());
	 return;
	
	
}

export default vpbindQuizEvents;
